<template>
  <div class="uploader">
    <slot name="title"></slot>

    <template v-if="errorList.length">
      <BaseAlert
          v-for="errorItem in errorList"
          :key="errorItem"
          class="p-2"
          variant="danger"
          dismissible
          show
      >{{ errorItem }}</BaseAlert
      >
    </template>

    <template v-if="pickedFiles.length">
      <div class="uploader__files overflow-auto">
        <b-card
            v-for="(pickedFile, pickedFileIdx) in pickedFiles"
            :key="pickedFileIdx"
            body-class="py-2 px-3"
            class="mb-2"
        >
          <div class="d-flex align-items-center">
            <b-icon
                v-if="uploadedFiles.includes(pickedFile.key)"
                icon="check-circle"
                variant="success"
                class="mr-2"
            ></b-icon>
            <b-icon
                v-else-if="failedFiles.includes(pickedFile.key)"
                icon="exclamation-circle"
                variant="danger"
                class="mr-2"
            ></b-icon>
            <b-icon
                v-else-if="uploadingFiles.includes(pickedFile.key)"
                icon="clock"
                class="mr-2"
            ></b-icon>
            <b-icon
                v-else-if="isUploading"
                icon="clock"
                class="text-gray mr-2"
            ></b-icon>

            <small>{{ pickedFile.file.name }}</small>

            <a
                v-if="
                  !uploadedFiles.includes(pickedFile.key) &&
                  !uploadingFiles.includes(pickedFile.key)
                "
                @click.prevent="() => handleFileRemove(pickedFile.key)"
                class="ml-auto"
                href
            >
              <b-icon icon="trash" variant="danger"></b-icon>
            </a>
          </div>
        </b-card>
      </div>

<!--      <div class="mt-3 d-flex align-items-center">-->
<!--        <b-button-->
<!--            @click.prevent="handleFileUpload"-->
<!--            :disabled="isUploading"-->
<!--            variant="primary"-->
<!--            class="px-3 ml-auto mr-0"-->
<!--            size="sm"-->
<!--        >Upload</b-button-->
<!--        >-->
<!--      </div>-->
    </template>

    <form :class="{ 'mt-4': pickedFiles.length }" class="uploader__box">
      <div
          @mouseover="() => (isHovering = true)"
          @mouseout="() => (isHovering = false)"
          class="uploader__box--inner"
      >
        <input
            v-bind="inputAttrs"
            @change="handleFilePicking"
            type="file"
            class="uploader__input"
            :disabled="isUploading"
        />

        <template v-if="isHovering">Drop documents here</template>
        <template v-else>
          Upload Supporting Documents (.pdf, .jpg, .xls, .xlsx)
          <!-- <template v-if="inputAttrs.accept"
            >({{ inputAttrs.accept }})</template>-->

        </template>
      </div>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import { defineComponent, ref } from '@vue/composition-api'
import uniqueId from 'lodash.uniqueid'

import { LincolnGlobalUMRService } from '@services'
import { BaseAlert } from '@components/base'
import CashCallService from "@services/CashCallService";

export default defineComponent({
  name: 'CashCallDocumentUploader',
  components: {
    BaseAlert
  },
  props: {
    inputAttrs: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const isHovering = ref(false)
    const isUploading = ref(false)
    const pickedFiles = ref([])
    const uploadingFiles = ref([])
    const uploadedFiles = ref([])
    const failedFiles = ref([])
    const errorList = ref([])

    const handleFilePicking = async (evt) => {
      const allowedExts = props.inputAttrs.accept
          ? props.inputAttrs.accept.split(',')
          : []

      pickedFiles.value = Array.from(evt.target.files)
          .filter((item) => {
            if (!allowedExts.length) return true

            const fileExt = `.${item.name.split('.').pop()}`

            if (!allowedExts.includes(fileExt)) {
              errorList.value.push(`${item.name} is invalid.`)

              return false
            } else {
              return true
            }
          })
          .map((item) => ({
            key: uniqueId(`item-file-${item.name}`),
            file: item
          }))
      // Automatically upload after picking files
      console.log("hello")
      console.log(pickedFiles.value)
      console.log("hello1")
      if (pickedFiles.value.length) {
        await handleFileUpload()
      }
    }

    const handleFileRemove = (key) => {
      const fileIndex = pickedFiles.value.findIndex((item) => item.key == key)

      if (0 <= fileIndex) pickedFiles.value.splice(fileIndex, 1)
    }

    const handleFileUpload = async () => {
      isUploading.value = true

      for await (const pickedFile of pickedFiles.value) {
        try {
          const formData = new FormData()

          formData.append('file', pickedFile.file)

          uploadingFiles.value.push(pickedFile.key)

          const { data } = await CashCallService.uploadFile(12, formData)
          const { data: results } = data || {}

          if (!!results.error) {
            failedFiles.value.push(pickedFile.key)
          } else {
            uploadedFiles.value.push(pickedFile.key)
            console.log(results)
            console.log(uploadedFiles.value)
          }
        } catch (_) {
          failedFiles.value.push(pickedFile.key)
        }
      }

      if (!failedFiles.value.length) {
        pickedFiles.value = []
        uploadingFiles.value = []

        Vue.prototype.$toasted.show('Files uploaded successfully.')

        Vue.prototype.$emitter.emit('files-uploaded', {
          type: 'bdx',
          success: true
        })
      } else {
        Vue.prototype.$toasted.show('Files upload failed.', {
          type: 'error'
        })
      }

      isUploading.value = false
      errorList.value = []
    }

    return {
      isHovering,
      isUploading,
      pickedFiles,
      uploadingFiles,
      uploadedFiles,
      failedFiles,
      errorList,
      handleFilePicking,
      handleFileRemove,
      handleFileUpload
    }
  }
})
</script>

<style lang="scss" scoped>
.uploader {
  position: relative;

  &__files {
    max-height: 300px;
  }

  &__box {
    background-color: #fff;
    padding: 15px;
    border-radius: 10px;
    box-shadow: rgba(#000, 0.1) 0 0 15px 0;

    &--inner {
      width: 100%;
      min-height: 100px;
      border: 1px dashed rgba(#000, 0.25);
      border-radius: inherit;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  &__input {
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
  